import React, { ReactNode } from "react";
import { Types as AlchemistTypes } from "alchemist";
import { BLOCKS, CommonNode } from "@foundation/rich-text-react-renderer";

import FeatureAd from "~components/articles/feature/FeatureAd";
import { ArticleBodyText } from "~components/shared";

import defaultOptions, { RichtextMedia } from "./richtext";

const MEDIA_DATA_ATTRIBUTES = [
    "data-image-type",
    "data-image-size",
    "data-align",
];
const AD_DATA_ATTRIBUTES = ["data-align", "data-ad-type"];

const getDataAttributesForNode = (
    data: { [attr: string]: string },
    props: string[]
) => {
    const dataAttributes: any = {};
    props.forEach((prop) => (dataAttributes[prop] = data?.[prop]));
    return dataAttributes;
};

const options = {
    ...defaultOptions,

    [BLOCKS.MEDIA]: (node: CommonNode) => {
        const subType = (node as unknown as AlchemistTypes.Media).subType;

        const dataAttributes: any = getDataAttributesForNode(
            node.data[subType] || {},
            MEDIA_DATA_ATTRIBUTES
        );

        // Default to standard richtext behavior
        return (
            <div {...dataAttributes}>
                <RichtextMedia node={node} />
            </div>
        );
    },

    [BLOCKS.AD]: (node: CommonNode) => {
        const dataAttributes: any = getDataAttributesForNode(
            node.data || {},
            AD_DATA_ATTRIBUTES
        );
        const adType = dataAttributes["data-ad-type"];

        return (
            <div {...dataAttributes} className="gap-1">
                <FeatureAd adType={adType} positionIncrement={node.data.num} />
            </div>
        );
    },

    [BLOCKS.PARAGRAPH]: (node: CommonNode, children: ReactNode) => (
        <ArticleBodyText isFeatured node={node}>
            {children}
        </ArticleBodyText>
    ),

    [BLOCKS.DIV]: (node: CommonNode, children: ReactNode) => {
        const dataAttributes: any = getDataAttributesForNode(
            node.data || {},
            AD_DATA_ATTRIBUTES
        );

        return (
            <div className="body-1 gap-1 font-article-body" {...dataAttributes}>
                {children}
            </div>
        );
    },

    [BLOCKS.INLINE_RECIRC]: (_: CommonNode) => null,
};

export default options;
